<template>
	<div class="itemedit page-container">
		<div class="page-title">
			拍卖信息编辑
		</div>
		<div class="page-content custom-scroll-bar">
			<el-form :model="commodityForm" :rules="rules" ref="commodityForm" label-width="150px" class="ruleForm">
				<el-form-item label="选择藏品" prop="commodityId">
					<el-select v-model="commodityForm.commodityId" placeholder="请选择要拍卖的藏品" @change="commodityChange">
						<el-option v-for="(item,index) in commodityList" :key="index" :label="item.lotName"
							:value="item.id"></el-option>
					</el-select>
				</el-form-item>
				<!-- <div class="upload-video">
					<div class="upload-key">
						藏品视频
					</div>
					<div class="upload-value">
						<video :src="commodityInfo.videoUrl" controls></video>
					</div>
				</div> -->
				<div class="upload-image">
					<div class="upload-key">
						藏品图片
					</div>
					<div class="upload-value">
						<!-- <img :src="item" v-for="(item,index) in commodityInfo.imageList" :key="index" alt=""
							@click="openDialog(item)"> -->
						<span class="choose-hint" v-if="commodityInfo.image_url == ''">请选择藏品</span>
						<img v-else :src="$pub.imageUrl+commodityInfo.image_url" alt="" @click="openDialog(commodityInfo.image_url)">
					</div>
					<el-dialog :visible.sync="dialogVisible">
						<img width="100%" :src="$pub.imageUrl+dialogImageUrl" alt="">
					</el-dialog>
				</div>
				<el-form-item label="创作完成时间" prop="create_time">
					<el-input type="text" placeholder="创作完成时间" v-model="commodityInfo.create_time" :disabled="true">
					</el-input>
					</el-date-picker>
				</el-form-item>
				<el-form-item label="藏品作者(发行方)" prop="author">
					<el-input type="text" placeholder="藏品作者(发行方)" v-model="commodityInfo.author" :disabled="true">
					</el-input>
				</el-form-item>
				<el-form-item label="藏品类别" prop="type">
					<el-input type="text" placeholder="藏品类别" v-model="commodityInfo.type" :disabled="true">
					</el-input>
				</el-form-item>
				<el-form-item label="藏品标签" prop="tags">
					<el-input type="text" placeholder="藏品类别" v-model="commodityInfo.tags" :disabled="true">
					</el-input>
				</el-form-item>
				<el-form-item label="是否参加活动" prop="activityFlag">
					<el-switch v-model="activityFlag" active-text="是" inactive-text="否" @change="activityFlagChange">
					</el-switch>
				</el-form-item>
				<el-form-item label="拍卖活动" prop="activity">
					<el-select v-model="commodityForm.activity" filterable placeholder="请选择拍卖活动"
						:disabled="!activityFlag" @change="activityChange">
						<el-option v-for="item in activityList" :key="item.id" :label="item.activityName"
							:value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="拍卖开始时间">
					<el-col :span="4">
						<el-form-item prop="date1" :rules=" [{ required: true,
					trigger: 'blur' , message: '请选择拍卖开始时间' }]">
							<el-date-picker type="date" placeholder="选择日期" :disabled="timeFlag"
								v-model="commodityForm.date1" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
								:picker-options="pickerOptions">
							</el-date-picker>
						</el-form-item>
					</el-col>
					<el-col :span="4">
						<el-form-item prop="date2" :rules=" [{ required: true,
					trigger: 'blur' , message: '请选择拍卖开始时间' }]">
							<el-time-picker placeholder="选择时间" v-model="commodityForm.date2" :disabled="timeFlag"
								value-format="HH:mm:ss">
							</el-time-picker>
						</el-form-item>
					</el-col>
				</el-form-item>
				<el-form-item label="拍卖结束时间">
					<el-col :span="4">
						<el-form-item prop="date3" :rules=" [{ required: true,
					trigger: 'blur' , message: '请选择拍卖结束时间' }]">
							<el-date-picker type="date" placeholder="选择日期" v-model="commodityForm.date3"
								format="yyyy-MM-dd" value-format="yyyy-MM-dd" :disabled="timeFlag"
								:picker-options="pickerOPtions2">
							</el-date-picker>
						</el-form-item>
					</el-col>
					<el-col :span="4">
						<el-form-item prop="date4" :rules=" [{ required: true,
					trigger: 'blur' , message: '请选择拍卖结束时间' }]">
							<el-time-picker placeholder="选择时间" v-model="commodityForm.date4" :disabled="timeFlag"
								value-format="HH:mm:ss">
							</el-time-picker>
						</el-form-item>
					</el-col>
				</el-form-item>
				<el-form-item type="number" label="保证金" prop="deposit">
					<el-input v-model="commodityForm.deposit" placeholder="请输入保证金" :disabled="depositFlag">
						<template slot="append">
							元
						</template>
					</el-input>
				</el-form-item>
				<el-form-item label="保证金变更方式" prop="depositType">
					<el-select v-model="commodityForm.depositType" placeholder="保证金变更方式">
						<el-option v-for="(item,index) in depositTypeList" :key="index" :label="item.label"
							:value="item.value"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item type="number" label="起拍价" prop="start">
					<el-input v-model="commodityForm.start" placeholder="请输入起拍价" :disabled="startFlag">
						<template slot="append">
							元
						</template>
					</el-input>
				</el-form-item>
				<el-form-item type="number" label="加价幅度" prop="add">
					<el-input v-model="commodityForm.add" placeholder="请输入加价幅度" :disabled="addFlag">
						<template slot="append">
							元
						</template>
					</el-input>
				</el-form-item>
				<el-form-item label="评估价" prop="evaluated">
					<el-input type="number" v-model="commodityForm.evaluated" placeholder="请输入评估价">
						<template slot="append">
							元
						</template>
					</el-input>
				</el-form-item>
				<!-- <el-form-item label="竞价周期" prop="cycle">
					<el-input v-model="commodityForm.cycle" placeholder="请输入竞价周期"></el-input>
				</el-form-item> -->
				<el-form-item label="延价周期" prop="postpone">
					<el-input type="number" v-model="commodityForm.postpone" placeholder="请输入延价周期">
						<template slot="append">
							分钟
						</template>
					</el-input>
				</el-form-item>
				<div class="rich-text">
					<div class="key">
						<span>*</span>拍品介绍：
					</div>
					<div class="value">
						<Tinymce v-if="richTextFlag" v-model="introduce" placeholder="请编辑您的拍品介绍..." :height="500">
						</Tinymce>
					</div>
				</div>
				<div class="rich-text">
					<div class="key">
						<span>*</span>拍卖公告：
					</div>
					<div class="value">
						<Tinymce v-if="richTextFlag" v-model="notice" placeholder="请编辑您的拍卖公告..." :height="500">
						</Tinymce>
					</div>
				</div>
				<div class="upload-datum">
					<div class="upload-key">
						拍卖资料（PDF）：
					</div>
					<div class="upload-value">
						<el-upload class="avatar-uploader" :action="uploadFileUrl" :show-file-list="false"
							:on-success="handleDatumSuccess" :before-upload="beforeDatumUpload"
							:headers="{Authtoken:token}" accept=".pdf">
							<img class="avatar" src="../../../assets/pdf.png" alt="" v-if="datumUrl!=''">
							<i v-else class="el-icon-plus avatar-uploader-icon"></i>
						</el-upload>
						<span>{{fileName}}</span>
					</div>
				</div>
				<div class="rich-text">
					<div class="key">
						<span>*</span>报名须知：
					</div>
					<div class="value">
						<Tinymce v-if="richTextFlag" v-model="diccover" placeholder="请编辑您的报名须知..." :height="500">
						</Tinymce>
					</div>
				</div>
				<div class="rich-text">
					<div class="key">
						<span>*</span>拍卖规则：
					</div>
					<div class="value">
						<Tinymce v-if="richTextFlag" v-model="rule" placeholder="请编辑您的拍卖规则..." :height="500"></Tinymce>
					</div>
				</div>
				<div class="login-button">
					<el-button type="primary" :loading="loading" @click="saveCommodityInfo">保存拍卖信息</el-button>
				</div>
			</el-form>
		</div>
	</div>
</template>

<script>
	import Tinymce from '@/components/Tinymce'
	export default {
		name: 'itemedit',
		components: {
			Tinymce
		},
		data() {
			return {
				commodityInfo: {
					image_url: '',
					create_time: '',
					author: '',
					type: '',
					tags: ''
				},
				activityFlag: false,
				activityList: [],
				commodityList: [],
				commodityForm: {
					commodityId: '',
					date1: '',
					date2: '',
					date3: '',
					date4: '',
					deposit: '',
					depositType: '',
					start: '',
					evaluated: '',
					add: '',
					cycle: '',
					postpone: '',
					activity: ''
				},
				depositTypeList: [{
						label: '退还保证金，全额支付。',
						value: 1
					},
					{
						label: '不退还保证金，抵扣拍卖金额。',
						value: 0
					}
				],
				rules: {
					commodityId: [{
						required: true,
						trigger: 'change',
						message: '请选择要拍卖的藏品'
					}],
					date1: [{
						required: true,
						trigger: 'blur',
						message: '请选择拍卖开始日期'
					}],
					date2: [{
						required: true,
						trigger: 'blur',
						message: '请选择拍卖开始时间'
					}],
					deposit: [{
						required: true,
						trigger: 'blur',
						message: '请输入保证金'
					}],
					depositType: [{
						required: true,
						trigger: 'change',
						message: '请选择保证金变更方式'
					}],
					start: [{
						required: true,
						trigger: 'blur',
						message: '请输入起拍价'
					}],
					evaluated: [{
						required: true,
						trigger: 'blur',
						message: '请输入评估价'
					}],
					add: [{
						required: true,
						trigger: 'blur',
						message: '请输入加价幅度'
					}],
					// cycle: [{
					// 	required: true,
					// 	trigger: 'blur',
					// 	message: '请输入竞价周期'
					// }],
					postpone: [{
						required: true,
						trigger: 'blur',
						message: '请输入延价周期'
					}]
				},
				uploadFileUrl: '',
				dialogImageUrl: '',
				dialogVisible: false,
				disabled: false,
				introduce: '',
				notice: '',
				diccover: '',
				rule: '',
				datumUrl: '',
				loading: false,
				commodityType: '',
				activityType: '',
				timeFlag: false,
				startFlag: false,
				addFlag: false,
				depositFlag: false,
				typeFlag: false,
				token: '',
				fileName: '',
				editFlag: false,
				richTextFlag: false,
				pickerOptions: {
					disabledDate: time => {
						if (this.commodityForm.date3) {
							return (
								time.getTime() < Date.now() - 8.64e7 ||
								time.getTime() > Date.parse(this.commodityForm.date3) /*开始日期要在选择的结束日期之前*/
							);
						}
						return time.getTime() < Date.now() - 8.64e7; /*今天及以后*/
						// return time.getTime() > Date.now() - 8.64e6; /*今天及之前，注意数字不一样*/
					}
				},
				pickerOPtions2: {
					disabledDate: time => {
						if (this.commodityForm.date1) {
							return (
								time.getTime() < Date.now() - 8.64e6 ||
								time.getTime() < Date.parse(this.commodityForm.date1) /*结束日期要在选择的开始日期之后*/
							);
						}
						return time.getTime() < Date.now() - 8.64e7; /*今天及以后*/
						// return time.getTime() > Date.now() - 8.64e6; /*今天及之前*/
					}
				}
			};
		},
		methods: {
			// 图片列表预览
			openDialog(url) {
				if (url == '') return
				this.dialogImageUrl = url;
				this.dialogVisible = true;
			},
			// 上传资料
			handleDatumSuccess(res, file) {
				if (res.code == 200) {
					this.datumUrl = res.data.fileUrl
					this.fileName = file.name
				}
			},
			// 上传资料前
			beforeDatumUpload(file) {
				const isLt2M = file.size / 1024 / 1024 < 50;
				if (!isLt2M) {
					this.$message.error('上传文件大小不能超过 50MB!');
				}
				return isLt2M;
			},
			saveCommodityInfo() {
				if (this.introduce == '') {
					this.$message({
						message: '请填写拍品介绍',
						type: 'error',
						duration: 2000
					})
					return
				}
				if (this.notice == '') {
					this.$message({
						message: '请填写拍卖公告',
						type: 'error',
						duration: 2000
					})
					return
				}
				// if (this.datumUrl == '') {
				// 	this.$message({
				// 		message: '请上传拍卖资料',
				// 		type: 'error',
				// 		duration: 2000
				// 	})
				// 	return
				// }
				if (this.diccover == '') {
					this.$message({
						message: '请填写报名须知',
						type: 'error',
						duration: 2000
					})
					return
				}
				if (this.rule == '') {
					this.$message({
						message: '请填写拍卖规则',
						type: 'error',
						duration: 2000
					})
					return
				}
				this.$refs.commodityForm.validate(valid => {
					if (valid) {
						this.loading = true
						let data = {
							id: this.commodityForm.commodityId,
							activityId: this.commodityForm.activity,
							startTime: this.commodityForm.date1 + ' ' + this.commodityForm.date2,
							endTime: this.commodityForm.date3 + ' ' + this.commodityForm.date4,
							bond: this.commodityForm.deposit,
							bondType: this.commodityForm.depositType,
							startPrice: this.commodityForm.start,
							priceIncreaseRange: this.commodityForm.add,
							evaluationPrice: this.commodityForm.evaluated,
							biddingPeriod: this.commodityForm.cycle,
							delayPeriod: this.commodityForm.postpone,
							objectIntroduce: this.introduce,
							auctionAnnouncement: this.notice,
							notice: this.diccover,
							auctionRule: this.rule,
							dataUrl: this.datumUrl,
							relation: 1
						}
						if(this.editFlag){
							this.$api.auctionGoodsUpdate(data, res => {
								this.loading = false
								if (res.code == 200) {
									this.$message({
										message: '编辑拍卖品成功。',
										duration: 2000,
										type: 'success',
										onClose: () => {
											this.$router.back()
										}
									})
								}
							})
						}else{
							this.$api.auctionGoodsAdd(data, res => {
								this.loading = false
								if (res.code == 200) {
									this.$message({
										message: '新增拍卖品成功。',
										duration: 2000,
										type: 'success',
										onClose: () => {
											this.$router.back()
										}
									})
								}
							})
						}
					}
				})
			},
			fetchCommodity() {
				this.$api.commodityAll({}, res => {
					if (res.code == 200) {
						this.commodityList = res.data
					}
				})
			},
			commodityChange(e) {
				this.$api.auctionGoodsDetail({
					id: e
				}, res => {
					if (res.code == 200) {
						this.commodityInfo = {
							image_url: res.data.lotPictrueUrl,
							create_time: res.data.finishTime,
							author: res.data.lotAuthor,
							type: res.data.lotType,
							tags: res.data.lotLabel
						}
						this.commodityType = res.data.lotOneType + ',' + res.data.lotTwoType
						this.comparison()
						if (this.editFlag) {
							if (res.data.activityId != '' && res.data.activityId != null) {
								this.activityFlag = true
								this.commodityForm.activity = res.data.activity
								this.activityChange(this.commodityForm.activity)
							} else {
								this.commodityForm.date1 = res.data.startTime.split(' ')[0]
								this.commodityForm.date2 = res.data.startTime.split(' ')[1]
								this.commodityForm.date3 = res.data.endTime.split(' ')[0]
								this.commodityForm.date4 = res.data.endTime.split(' ')[1]
								this.commodityForm.start = res.data.startPrice
								this.commodityForm.deposit = res.data.bond
								this.commodityForm.depositType = res.data.bondType
								this.commodityForm.add = res.data.priceIncreaseRange
								this.commodityForm.evaluated = res.data.evaluationPrice
								this.commodityForm.cycle = res.data.biddingPeriod
								this.commodityForm.postpone = res.data.delayPeriod
								this.commodityInfo.type = res.data.lotOneTypeName + ',' + res.data.lotTwoTypeName
								this.introduce = res.data.objectIntroduce
								this.notice = res.data.auctionAnnouncement
								this.diccover = res.data.notice
								this.rule = res.data.auctionRule
								this.datumUrl = res.data.dataUrl
								this.richTextFlag = true
							}
						}
					}
				})
			},
			fetchActivity() {
				this.$api.activityAll({}, res => {
					if (res.code == 200) {
						this.activityList = res.data
					}
				})
			},
			activityChange(e) {
				this.$refs['commodityForm'].clearValidate("date1")
				this.$refs['commodityForm'].clearValidate("date3")
				this.$api.activityDetail({
					id: e
				}, res => {
					if (res.code == 200) {
						this.timeFlag = res.data.isAuctionTime == 1
						if (this.timeFlag) {
							this.commodityForm.date1 = res.data.startTime.split(' ')[0]
							this.commodityForm.date2 = res.data.startTime.split(' ')[1]
							this.commodityForm.date3 = res.data.endTime.split(' ')[0]
							this.commodityForm.date4 = res.data.endTime.split(' ')[1]
						}
						this.startFlag = res.data.isStartPrice == 1
						if (this.startFlag) {
							this.commodityForm.start = res.data.startPrice
						}
						this.depositFlag = res.data.isBond == 1
						if (this.depositFlag) {
							this.commodityForm.deposit = res.data.bond
						}
						this.addFlag = res.data.isRange == 1
						if (this.addFlag) {
							this.commodityForm.add = res.data.priceIncreaseRange
						}
						this.typeFlag = res.data.isTypeLimit == 1
						this.activityType = res.data.lotTypeId
						this.comparison()
					}
				})
			},
			comparison() {
				// 先判断是否限制藏品类别
				if (this.typeFlag) {
					// 判断是否为空，是否相同
					if (this.commodityType != '' && this.activityType != '' && this.commodityType != this.activityType) {
						this.$alert('活动已限制藏品类别，当前藏品类别与活动要求不一致，请重新选择藏品或者活动。', '提示', {
							confirmButtonText: '确定',
						});
					}
				}
			},
			activityFlagChange() {
				if (!this.activityFlag) {
					this.commodityForm.activity = ''
					this.timeFlag = false
					this.commodityForm.date1 = ''
					this.commodityForm.date2 = ''
					this.commodityForm.date3 = ''
					this.commodityForm.date4 = ''
					this.startFlag = false
					this.commodityForm.start = ''
					this.depositFlag = false
					this.commodityForm.deposit = ''
					this.addFlag = false
					this.commodityForm.add = ''
					this.typeFlag = false
					this.activityType = ''
				}
			}
		},
		beforeCreate: function() {
			//生命周期 -- 组件实例刚被创建，组件属性计算之前，如DATA属性等
		},
		created: function() {
			//生命周期 -- 组件实例创建完成，属性已绑定，但DOM还未生成，$el属性还不存在
			this.uploadFileUrl = this.$pub.requestUrl + 'uploadImg'
			this.token = this.$pub.getStorage('adm_token')
		},
		beforeMount: function() {
			//模板编译/挂载之前
		},
		mounted: function() {
			//模板编译/挂载之后
			this.fetchCommodity()
			this.fetchActivity()
			if (this.$route.query.id) {
				this.commodityForm.commodityId = this.$route.query.id
				this.editFlag = true
				this.commodityChange(this.commodityForm.commodityId)
			} else {
				this.richTextFlag = true
			}
		},
		beforeUpdate: function() {
			//组件更新之前
		},
		updated: function() {
			//组件更新之后
		},
		activated: function() {
			// for keep-alive，组件被激活时调用
		},
		deactivated: function() {
			// for keep-alive，组件被移除时调用
		},
		beforeDestory: function() {
			// 组件销毁调用
		},
		destoryed: function() {
			// 组件销毁后调用
		}
	};
</script>

<style lang="less" scoped="scoped">
	.itemedit {
		overflow: hidden;
	}

	.page-title {
		width: 100%;
		height: 50px;
		display: flex;
		align-items: center;
		padding: 0px @vue-spacing-row-sm;
		box-sizing: border-box;
		background: @vue-bg-color-grey;
	}

	.page-content {
		width: 100%;
		height: calc(100% - 50px);
		padding: @vue-spacing-col-base @vue-spacing-row-base;
		box-sizing: border-box;
		overflow: auto;
	}

	.upload-video,
	.upload-image,
	.upload-datum,
	.rich-text {
		display: flex;
		margin-bottom: @vue-spacing-col-lg;
	}

	.upload-key,
	.key {
		width: 150px;
		height: 50px;
		display: flex;
		align-items: center;
		justify-content: flex-end;
		padding-right: @vue-spacing-row-sm + 4;
		box-sizing: border-box;
		font-size: @vue-font-size-sm - 2;
		color: @vue-text-color;

		span {
			color: @vue-text-color-red;
		}
	}

	.upload-value,
	.value {
		width: calc(100% - 450px);
	}

	.upload-value {
		.choose-hint {
			width: 400px;
			height: 50px;
			display: flex;
			align-items: center;
			padding: 0px @vue-spacing-row-sm;
			border: 1px dashed @vue-border-color;
			font-size: @vue-font-size-sm - 2;
			box-sizing: border-box;
			color: @vue-text-color-grey;
		}

		video {
			width: 320px;
			height: 240px;
			background: #000000;
		}

		img {
			max-width: 800px;
			display: block;
		}
	}

	.el-input,
	.el-select {
		width: 400px;
	}

	.el-date-editor {
		width: 200px;
	}

	.avatar-uploader .el-upload {
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 178px;
		height: 178px;
		line-height: 178px;
		text-align: center;
		border: 1px dashed #d9d9d9;
		box-sizing: border-box;
		border-radius: @vue-border-radius-base;
		background: #fbfdff;
	}

	.avatar-uploader-icon:hover {
		border-color: #409EFF;
	}

	.avatar {
		width: 178px;
		height: 178px;
		display: block;
	}

	.video {
		width: 148px;
		height: 148px;
		display: block;
	}

	.login-button {
		padding-left: 150px;
		box-sizing: border-box;
		margin-bottom: @vue-spacing-col-lg*2;

		.el-button {
			width: 200px;
		}
	}
</style>
